import React, { useState } from "react";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { SyledRowContainer, SyledForm } from "./styled";
import Form from "react-bootstrap/Form";

function Links() {
  const [name, setName] = useState("");
  const [link, setLink] = useState("");

  const handleName = (e) => {
    console.log(e.target.value);
    setName(e.target.value);
  };

  const handleLink = (e) => {
    setLink(e.target.value);
  };
  return (
    <SyledRowContainer>
      <Container>
        <Row>
          <Col
            lg={{ span: 11, offset: 1 }}
            style={{ paddingTop: "70px", paddingBottom: "70px" }}
          >
            <Row>
              <Col xs={12} sm={12} md={12} lg={6}>
                <h4 className="title">¿Querés recomendar una herramienta?</h4>
                <p className="text">
                  Completá esta información y sumá recursos para la comunidad.
                </p>
              </Col>
              <Col xs={12} sm={12} md={12} lg={6}>
                <SyledForm inline>
                  <div className="form-style">
                    <Form.Group className="mb-3" controlId="formBasicEmail">
                      <Form.Label>Nombre herramienta</Form.Label>
                      <Form.Control
                        type="text"
                        onChange={handleName}
                        style={{ borderRadius: "50px" }}
                      />
                    </Form.Group>
                    <Form.Group
                      className="mb-3 link"
                      controlId="formBasicEmail"
                    >
                      <Form.Label>Link</Form.Label>
                      <Form.Control
                        type="text"
                        onChange={handleLink}
                        style={{ borderRadius: "50px" }}
                      />
                    </Form.Group>
                    <a
                      href={`mailto:info@chequeado.com?subjetc=Contacto&body=Nombre de la herramienta${name}. Link de la herramienta${link}`}
                    >
                      <button variant="primary" type="submit">
                        Enviar sugerencia
                      </button>
                    </a>
                  </div>
                </SyledForm>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </SyledRowContainer>
  );
}

export default Links;
